<template lang="pug">
  a(:class="lang", :href='path')
    #released_timestamp
      | Released: {{date}}
</template>
<script>
  import {mapState} from 'vuex';

  export default {
    data: function(){
      return {
        ja_path: './index.html',
        en_path: '/en/data-visualizations/dv06/index.html',
        date: 'March 29, 2019'
      }
    },
    computed: {
      ...mapState([
        'lang',
      ]),
      path: function(){
        if(/ja/.test(this.lang)){
          return this.ja_path;
        }else{
          return this.en_path;
        }
      },
    }

  };

</script>
<style lang="sass">
  #released_timestamp
    float: right
</style>